
import { IGlobalState } from "@/store";
import HEADER_MENU from "@/typings/app";
import { IApplication } from "@/typings/application";
import { computed, defineComponent, onMounted, reactive, toRefs,PropType } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
interface Imenu {
    id: string;
    name: string;
    path: string;
}

export default defineComponent({
  props: {
    isAppInside: {
      type: Boolean,
      default: false
    },
    menuList: {
      type: [Array] as PropType<Imenu[]>,
      default: () => []
    },
    application: {
      type: Object as PropType<IApplication>,
      default: null
    }
  },
  setup(props, context) {
    const store = useStore<IGlobalState>();
    const router = useRouter();
    const state = reactive({
      mobile: computed(() => store.state.user.mobile),
      enterpriseFullName: computed(() => store.state.user.enterpriseFullName),
      examineState: computed(() => store.state.user.examineState),
      curMenu:props.menuList[0],
      aliyunPath:store.state.app.aliyunPath + "/",
      isShowMobile:false
    });
    // 头部当前选中的菜单下标
    const headerMenuIndex = computed({
      get: () => store.state.app.headerMenuIndex,
      set: (val) => {
        store.state.app.headerMenuIndex = val;
      }
    });
    /**
     * 改变当前选中菜单
     */
    function changeCurMenu(menu: Imenu){
      state.curMenu = menu;
    }
    /**
     * 跳转至当前选中菜单
     */
     function gotoCurMenu(menu: Imenu){
       router.push({ path: menu.path, query: router.currentRoute.value.query });
    }
    /**
     * 点击菜单触发
     */
    function clickMenuItem(menu: Imenu){
      changeCurMenu(menu);
      gotoCurMenu(menu);
    }
    /**
     * 页面一开始加载就进入第一个菜单页面
     */
    onMounted(() => {
      if (process.env.VUE_APP_FORM_KEY != 'gzopen') {
        state.isShowMobile = true;
      } else {
        state.isShowMobile = false;
      }
      router.push({ path: props.menuList[0].path, query: router.currentRoute.value.query });
      headerMenuIndex.value = HEADER_MENU.PERSONAL;
    });

    return {
      ...toRefs(state),
      props,
      clickMenuItem
    };
  },
});
